import { FunctionComponent } from 'react';
import config from '@config';
import SmoothImage from '@xFrame4/components/common/SmoothImage';
import ALink from '@xFrame4/components/next/ALink';

export interface HeaderLogoProps
{
    language: string;
    className?: string;
    onClick?: () => void;
}

/**
 * Component: header logo
 */
const HeaderLogo: FunctionComponent<HeaderLogoProps> = (props) =>
{
    /** Render */
    return (
        <ALink href={`/${props.language}`} onClick={props.onClick}>
            <SmoothImage
                src={config.defaultPublicDirBaseUrl + 'img/logo/logo.webp'}
                width={256}
                height={184}
                className={`header-logo ${props.className}`}
            />
        </ALink>
    );
}

export default HeaderLogo;